import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: "100%",
  },
  paper: {
    maxHeight: "100vh",
    height: "100vh",
  },
  root1: {
    margin: 0,
    // marginLeft: -8,
    borderRadius: 0,
    // marginTop: 50
  },
  root2: {
    margin: 0,
    // marginLeft: -8,
    // borderRadius: 0,
    maxWidth: "960px",
    // alignItems:"center",
    marginInline: "auto",
    borderRadius: 8,
    borderWidth: 2,
    // marginLeft:"45px",
    // marginRight:"65px"
    // marginTop: 50
  },
  root: {
    flexGrow: 1,
    // marginTop: "50px",
    // marginBottom: "100px",
    // padding: "10px"
  },
  panel: {
    "& .MuiPaper-root": {
      padding: 0,
    },
    backgroundColor: "pink",
  },
  wrapHeader: {
    marginTop: "40%",
    // paddingTop: "60px",
    "& img": {
      transition: "all 0.2s ease-in-out",
    },
    "& img:hover": {
      cursor: "pointer",
      opacity: "0.9",
      transition: "all 0.2s ease-in-out",
    },
  },
  img: {
    filter: "brightness(55%)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    width: "100%",
    height: 300,
  },

  large: {
    width: 120,
    height: 120,
    border: "2px solid #5675D3",
    marginTop: "75%",
  },
  wrapHeaderToko: {
    display: "grid",
    padding: "15px",
    justifyItems: "center",
    // margin: "0",
    // position: "absolute",
    // top: "210px",
    // left: "50%",
    // msTransform: "translate(-50%, -50%)",
    // transform: "translate(-50%, -50%)",
    // backgroundColor: "rgba(255, 255, 255, 0.6)",
    // borderRadius: 5,
  },
  wrapAvatar: {
    display: "flex",
    alignItems: "center",
    "& label:hover": {
      cursor: "pointer",
    },
  },
  wrapDetail: {
    marginLeft: "20px",
    display: "contents",
  },
  liquidRow: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    width: "100%",
  },
  liquidTitle: {
    color: "black",
    // width: 150,
    // width: "max-content",
    // marginRight: 10,
    fontSize: 17,
  },
  liquidLabel: {
    color: "grey",
    // width: 150,
    // width: "max-content",
    // marginRight: 10,
    fontSize: 12.5,
  },
  liquidAlert: {
    color: "black",
    // width: "350px",
    // width: "max-content",
    // marginRight: 10,
    fontSize: 14,
  },
  liquidValue: {
    color: theme.palette.textColor.black,
    fontSize: 20,
    fontWeight: "bold",
    // width: "75%",
    margin: 15,
    marginBottom: "5px",
    wordBreak: "break-all",
  },
  fab: {
    marginLeft: theme.spacing(2),
  },
  fab1: {
    display: "flex",
    position: "fixed",
    bottom: "60px",
    right: "15px",
  },
}));

export default useStyles;
